// client/api.js — tiny wrappers around the Worker API (see docs/API.md).

// The same bundle supports beta.mitran.io and the consolidated /app mount.
export const appPath = path => `${location.pathname === '/app' || location.pathname.startsWith('/app/') ? '/app' : ''}${path}`;

/** JSON request. Throws an Error with .status on non-2xx. 401 means "show the gate". */
export async function api(path, { method = "GET", body, signal } = {}) {
  const res = await fetch(appPath(path), {
    method,
    signal,
    credentials: "same-origin",
    headers: body ? { "Content-Type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

/** ws:// or wss:// URL for an API path on this origin. */
export function wsUrl(path) {
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}${appPath(path)}`;
}

/** Fire-and-forget POST that survives the page closing (tab close, app kill). */
export function beacon(path) {
  try {
    navigator.sendBeacon(appPath(path), new Blob(["{}"], { type: "application/json" }));
  } catch {}
}
